import { Box } from "@mui/material";
import { EventId } from "src/models/sessions";

const ICON: Record<EventId, string> = {
  "pft-situps": "situps",
  "pft-plank": "plank",
  "pft-mile": "mile",
  "pft-beep-20m": "beep",
  "pft-beep-15m": "beep",
  "pft-pushups": "pushups",
  "pft-pullups": "pullups",
};

/** Event pictogram drawn as a CSS mask, so it takes the surrounding text color. */
export const EventIcon = ({
  eventId,
  size = 28,
}: {
  eventId: EventId;
  size?: number;
}) => {
  const mask = `url(/assets/events/${ICON[eventId]}.svg) center / contain no-repeat`;
  return (
    <Box
      component="span"
      aria-hidden="true"
      data-testid={`event-icon-${eventId}`}
      sx={{
        width: size,
        height: size,
        flex: "none",
        color: "primaryInk",
        bgcolor: "currentColor",
        WebkitMask: mask,
        mask,
      }}
    />
  );
};

export default EventIcon;
